export class EntAnimalBreedFilter {
  name: string | null = null;
  animalType: number | null = null;
  createdFrom: string | null = null;
  createdTo: string | null = null;
  page: number = 1;
  size: number = 30;
}
